import { render, staticRenderFns } from "./MastheadStoryAspectRatio.vue?vue&type=template&id=3ef51cfb&scoped=true&"
import script from "./MastheadStoryAspectRatio.vue?vue&type=script&lang=js&"
export * from "./MastheadStoryAspectRatio.vue?vue&type=script&lang=js&"
import style0 from "./MastheadStoryAspectRatio.vue?vue&type=style&index=0&id=3ef51cfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef51cfb",
  null
  
)

export default component.exports